import Vue from 'vue';
import VueGoogleCharts from 'vue-google-charts';
import Offset from '@/components/helper/Offset';

Vue.component(Offset.name, Offset);
Vue.use(VueGoogleCharts);
